import { AspectRatio, Box, Heading, Stack, Text } from '@chakra-ui/react';
import HeroContainer from '@components/layout/layout/DefaultLayout';

const CovidVaccine = () => (
  <HeroContainer>
    <Box bg="blue.50" w="100%" p={3} mb="75px">
      <Stack spacing={5} pt="50px" m="0px auto" maxW="700px" w="100%">
        <Heading fontSize="3xl">The COVID Vaccine</Heading>
        <Text fontSize="xl">A state-by-state guide to whether you can get it, where, and how to get updates.</Text>
        <Box>
          <AspectRatio h="533px" m="0px auto">
            <iframe
              title="COVID Vaccine Airtable"
              src="https://airtable.com/embed/shrqDCDkmznPHrUZa?backgroundColor=orange&amp;layout=card&amp;viewControls=on"
              style={{
                background: 'transparent; border: 1px solid #ccc',
              }}
            />
          </AspectRatio>
        </Box>
      </Stack>
    </Box>
  </HeroContainer>
);

export default CovidVaccine;
